import {bulkActionsActions} from '@igp/shared/features/bulk-operation';
import {playerReferralActions} from '@igp/shared/features/player-referral';
import {userProfileActions} from '@igp/shared/features/user-profile';
import {actions as asyncActions} from '@igp/shared/redux/async-action';
import {downloadActions} from '@igp/shared/redux/download';
import {entityActions, realtimeActions, viewActions} from '@redux';

import {boUserActions} from '@features/bo-user/actions';
import {debtResponsibleMasterAgentActions} from '@features/debt-responsible-master-agent';
import {debtTransferLogActions} from '@features/debt-transfer-log';
import {referralLinkConfigActions} from '@features/referral-link-config';
import {repaymentLogActions} from '@features/repayment-log/actions';

const actions: {
    asyncActions: typeof asyncActions;
    viewActions: typeof viewActions;
    entityActions: typeof entityActions;
    realtimeActions: typeof realtimeActions;
    userProfileActions: typeof userProfileActions;
    bulkActionsActions: typeof bulkActionsActions;
    debtResponsibleMasterAgentActions: typeof debtResponsibleMasterAgentActions;
    downloadActions: typeof downloadActions;
    repaymentLogActions: typeof repaymentLogActions;
    boUserActions: typeof boUserActions;
    referralLinkConfigActions: typeof referralLinkConfigActions;
    playerReferralActions: typeof playerReferralActions;
    debtTransferLogActions: typeof debtTransferLogActions;
} = {
    asyncActions,
    viewActions,
    entityActions,
    realtimeActions,
    userProfileActions,
    bulkActionsActions,
    debtResponsibleMasterAgentActions,
    downloadActions,
    repaymentLogActions,
    boUserActions,
    referralLinkConfigActions,
    playerReferralActions,
    debtTransferLogActions,
};

export default actions;
export type RootActions = typeof actions;
